module.exports = __webpack_public_path__ + "img/gLogo.9034a82e.png";